import { axios } from "../../helper/axios";
import { addStationConstants} from "./addStationConstant";

const addStationApis = {};

addStationApis.addStation =(data) => {  
  const payload = data

  let res = axios.post(addStationConstants.ADD_STATION_API, payload);
 
  return res;
};
  
addStationApis.EditStation=(
{  id,
    name,
    mobile,
    email,
    network_id,
    type,
    open_time,
    close_time,
    station_url,
    landmark,
    address,
    address2,
    pin,
    street,
    city,
    state,
    country,
    latitude,
    longitude,
}
)=>{
  const postUpdatedData = {
    id,
    name,
    mobile,
    email,
    network_id,
    type,
    open_time,
    close_time,
    station_url,
    landmark,
    address,
    address2,
    pin,
    street,
    city,
    state,
    country,
    latitude,
    longitude,
    
  };
  return axios.put(addStationConstants.ADD_STATION_API, postUpdatedData);


}




/// add amenity

addStationApis.AddAmenities_Api = ({
  station_id,
  amenity_id
}) => {
  const postData = {
    station_id,
    amenity_id

  };
  return axios.post(addStationConstants.ADD_AMENITIES_API, postData);
};



addStationApis.RemoveAmenities_Api = ({
  station_id,
  amenity_id
}) => {
  const postData = {
    station_id,
    amenity_id

  };

  return axios.post(addStationConstants.REMOVE_AMENITIES_API, postData);
};


export default addStationApis;
